<template>
  <div>
    <v-tabs
      v-model="tabProxy"
      background-color="#F5F5F5"
      active-class="black--text"
      slider-color="black"
      show-arrows
      v-if="tabs.length > 0"
      align-with-title
      eager
    >
      <v-tab
        v-for="(onglet, index) in tabs"
        :key="index"
        :disabled="disabled"
        class="text-body-1"
      >
        {{ onglet }}
      </v-tab>
    </v-tabs>
  </div>
</template>
<script>
import { computed, defineComponent } from "@vue/composition-api";
import global from "@/composables/global";

export default defineComponent({
  props: {
    tabs: Array,
    disabled: Boolean,
  },
  setup() {
    /* Computed */
    const tabProxy = computed({
      get: function () {
        return global.selectedAppTab;
      },
      set: function (newValue) {
        global.selectedAppTab = newValue;
      },
    });

    return {
      tabProxy,
    };
  },
});
</script>
